import { render, staticRenderFns } from "./OnlineJoin.vue?vue&type=template&id=afbd833c&"
import script from "./OnlineJoin.vue?vue&type=script&lang=js&"
export * from "./OnlineJoin.vue?vue&type=script&lang=js&"
import style0 from "./OnlineJoin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports